import {observer} from "mobx-react";
import Accordion from "../../models/Accordion";
import {Navigation, Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import img from "../../assets/img/pigini_p1.jpeg";
import img2 from "../../assets/img/excelsior_p1.jpeg";
import placeholder from '../../assets/img/placeholder_accordion.webp'
import React, {useEffect, useState} from "react";
import Image from "../../models/Image";
import {useStore} from "../../stores/Store";
import "./ImageSwiper.css";
import {Box, CircularProgress} from "@mui/material";


export interface Props {
    accordion: Accordion
}

export default observer(function ImageSwiper({accordion}: Props){
    const { ImageStore } = useStore();
    const [images, setImages] = useState<Image[]>([])
    const [imagesAreLoading, setImagesAreLoading] = useState<boolean>(true);

    const loadImages = async () => {
        if(!accordion) return;
        setImagesAreLoading(true);
        setImages(await ImageStore.loadImagesOfAccordion(accordion));
        setImagesAreLoading(false);
    }

    useEffect(() => {
        loadImages();
    }, [ImageStore.images.get(accordion.id)]);

    const renderImages = () => {
        if(images.length === 0) return null;
        try {
            return images.map((image, index) => (
                <SwiperSlide key={index.toString()} style={{borderRadius: '20px'}}>
                    <img src={image.data} alt={image.name} style={{borderRadius: '20px'}} />
                </SwiperSlide>
            ))
        } catch (e) {
            console.error(e)
            return null
        }
    }

    const renderPlaceholder = () => {
        if(images.length > 0) return null;
        return (
            <>
                <SwiperSlide key={'0'}>
                    <img src={img} alt={'img1'} />
                </SwiperSlide>
                <SwiperSlide key={'1'}>
                    <img src={img2} alt={'img2'} />
                </SwiperSlide>
            </>
        )
    }

    return imagesAreLoading ?
    (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            minHeight: 300,
            position: 'relative'
        }}>
            <img src={placeholder} style={{
                borderRadius: '50%',
                opacity: '30%',
                position: 'absolute',
                height: '100%',
                objectFit: 'cover'
            }} />
            <CircularProgress color={'secondary'}  sx={{
                position: 'absolute',
                zIndex: '1'
            }}/>
        </Box>
    ) :
    (

        <Swiper
            pagination={true}
            navigation={true}
            modules={[Pagination, Navigation]}
            className={'swiper-accordion'}
        >
            { renderImages() }
            { renderPlaceholder() }
        </Swiper>
    )
});
